import { render, staticRenderFns } from "./EditCustomerDetail.vue?vue&type=template&id=b1d53302&"
import script from "./EditCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./EditCustomerDetail.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomerDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2983364112/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1d53302')) {
      api.createRecord('b1d53302', component.options)
    } else {
      api.reload('b1d53302', component.options)
    }
    module.hot.accept("./EditCustomerDetail.vue?vue&type=template&id=b1d53302&", function () {
      api.rerender('b1d53302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/ReplacementWidget/EditCustomerDetail.vue"
export default component.exports